@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.step-title {
  padding: @space-12 0;
}

.step-paragraph {
  padding-bottom: @space-12;
}

.auto-routing-flex-grid {
  margin-left: -20px;
  padding-top: @space-16;
  align-items: flex-start;
}

.auto-routing-wizard-img {
  height: 280px;
  margin-left: @space-24;
  margin-right: @space-24;
}

.auto-routing-wizard-list {
  padding-left: @space-24;
  margin-top: 0;
}

.product-table-img {
  width: 100%;
  height: auto;
  margin: 0;
  margin-bottom: @space-12;
}
